import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
  ElementRef,
  OnDestroy,
  Renderer2,
  //OnChanges,
} from '@angular/core';
import {
  TrnMain,
  TrnProd,
  //Warehouse,
  VoucherTypeEnum,
} from './../interfaces/TrnMain';
import { TransactionService } from './transaction.service';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Item } from './../interfaces/ProductItem';
//import { PurchaseInvoiceService } from "./purchaseinvoices.service";
import { MasterRepo } from './../repositories/masterRepo.service';
import { AppSettings } from './../services';
import { Observable } from 'rxjs';
import { Subscriber } from 'rxjs';
import { map } from 'rxjs/operators';
import { SettingService } from './../services';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
// import { LoginDialog } from "../../pages/modaldialogs/index";
// import { AutoComplete } from "primeng/components/autocomplete/autocomplete";
// import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { AuthService } from '../services/permission/authService.service';
import * as _ from 'lodash';
import {
  DataSourceType,
  GenericPopUpComponent,
  GenericPopUpSettings,
} from '../Popups/generic-grid/generic-popup-grid.component';
import { DispatchMain } from '../../pages/Inventory/components/dispatch/dispatch.component';

//import { GenericPopUpComponent, GenericPopUpSettings } from '../Popups/generic-grid/generic-popup-grid.component';

// import 'fix-table-header/jQuery.fixTableHeader.js';
declare var UltimateScrollingTable: any;

@Component({
  selector: 'productentry',
  templateUrl: './ProductInsert.html',
  styleUrls: ['../../pages/Style.css', './halfcolumn.css'],
})
export class ProductInsertComponent
  implements AfterViewInit, OnInit, OnDestroy
{
  @ViewChild('genericGridJCList') genericGridJCList!: GenericPopUpComponent;
  gridJCListSettings: GenericPopUpSettings = new GenericPopUpSettings();

  @ViewChild('genericGridProductList')
  genericGridProductList!: GenericPopUpComponent;
  gridMENUCODEsettings: GenericPopUpSettings = new GenericPopUpSettings();

  @ViewChild('MultiBCode') public MultiBCode!: ModalDirective;
  @ViewChild('prodlistTable') prodlistTable: ElementRef<HTMLElement> =
    {} as ElementRef;
  @ViewChild('onAddFocus') onAddFocus: any;
  @ViewChild('childModal') childModal!: ModalDirective;
  @ViewChild('quantityBox') quantityBox: ElementRef<HTMLInputElement> =
    {} as ElementRef;
  @ViewChild('rateBox') rateBox: ElementRef<HTMLInputElement> =
    {} as ElementRef;
  @ViewChild('discountBox') discountBox: ElementRef<HTMLInputElement> =
    {} as ElementRef;

  @Output() onAfterMainLoad = new EventEmitter();
  @Input() inputVchrType: string = '';

  DialogMessage: string = ' ';
  deliverytype: boolean = false;
  ServiceTaxRate: number = 0;
  VatRate: number = 0;
  selectedJob: any = <any>{};
  TrnMainObj: TrnMain = <TrnMain>{};
  warranty: any;
  sumList: any[] = [];
  result: any[] = [];
  stock: any;
  busy!: Subscription;
  @Input('voucherType') voucherType: VoucherTypeEnum = VoucherTypeEnum.Default;

  ItemList: Item[] = [];
  TrnProdObj: TrnProd = <TrnProd>{};
  subscriptions: Subscription[] = [];
  selectedItem: any = <any>{}; // this is for the product selected from http request
  private _selectedProd: any; // this is for the product selection in drop down
  sumListForItems: any[] = [];
  itemQty: any;
  mcode: any;
  mainVchr: any;
  public get selectedProd(): any {
    return this._selectedProd;
  }
  public set selectedProd(value: any) {
    this._selectedProd = value;
  }
  SelectedAltUnit: any = <any>{};
  IndDiscountValue: number = 0;
  radioIndDiscount!: string;
  flatDiscountValue: number = 0;
  radioFlatDiscount!: string;

  AppSettings!: AppSettings;
  Barcodes: any[] = [];
  SelectedBcode: any = <any>{};
  productForm!: FormGroup;
  selectedJobbb: any;
  showDiscount: boolean = true;
  itemTypeList: any[] = [];
  newWarranty: any;
  receivedTypeList: any[] = [];
  warrantyURL: any;
  w: any;
  snapshotParam: any;
  results!: Observable<Item[]>;
  lengths = false;
  SupplierList: any[] = [];
  form!: FormGroup;
  previousOpeningStockData: any[] = [];
  WarehouseWiseCounterMProduct: any[] = [];
  subscribedParam: any;
  JobList: any[] = [];
  DispatchName: any;
  modeTitle: any;
  mode: any;
  itemcheck = false;
  enableRealTimeStockCheck: boolean;
  selectedJobNo: any;

  constructor(
    public masterService: MasterRepo,
    private arouter: ActivatedRoute,
    private _trnMainService: TransactionService,
    private fb: FormBuilder,
    private setting: SettingService,
    public dialog: MatDialog,
    private renderer: Renderer2,
    private elref: ElementRef,
    private authService: AuthService,
    private _activatedRoute: ActivatedRoute
  ) {
    this.warranty = '0';
    this.enableRealTimeStockCheck = this.authService.getSetting();

    this.warrantyURL = this._activatedRoute.snapshot.params.returnUrl;
    console.log('warrantyURL', this.warrantyURL);

    if (this.warrantyURL === '/pages/inventory/dispatch') {
      this.warranty = '0';
      console.log('warranty', this.warranty);
    } else {
      this.warranty = '1';
      console.log('warranty', this.warranty);
    }

    this.newWarranty;
    console.log('warrantyyyy', this.newWarranty);

    try {
      this.itemcheck = false;
      this.selectedJob = null;

      this.TrnMainObj = _trnMainService.TrnMainObj;
      console.log({ productConstructTrnmain: this.TrnMainObj });
      this.TrnMainObj.ProdList = [];
      this.voucherType = this.TrnMainObj.VoucherType;
      this.AppSettings = setting.appSetting;
      this.ServiceTaxRate = this.setting.appSetting.ServiceTaxRate ?? 0;
      this.VatRate = this.setting.appSetting.VATRate ?? 0;
      this.jobValue = null;
      this.selectedJobNo = null;
      // this.masterService.getWarehouseWiseCounterProduct({ warehouse: authService.getUserProfile().userWarehouse }).subscribe(res => {
      //     if (res.status == "ok") {
      //         this.WarehouseWiseCounterMProduct = res.result;
      //     }

      // });
      // this.masterService.getSupplierList().subscribe(res => {
      //     this.SupplierList = res;
      // },
      //     error => {
      //         this.masterService.resolveError(error, 'product insert-getSupplierList');
      //     }, () => { });
      //this.masterService.getProductItemList();
      //this.ItemList = masterService.getProductItemList();
      if (this.masterService.DispatchName != null)
        this.DispatchName = this.masterService.DispatchName;
      this.masterService._itemList = [];

      this.productForm = this.fb.group({
        BC: '',
        MENUCODE: ['', [Validators.required]],
        selectedProd: ['', [Validators.required]],
        SelectedAltUnit: ['', [Validators.required]],

        UNIT: ['', Validators.required],
        RATE: ['', [Validators.required]],
        Quantity: ['', [Validators.required]],
        AMOUNT: ['', [Validators.required]],
        IndDiscountValue: ['', [Validators.required]],
        radioIndDiscount: ['', [Validators.required]],
        EXPDATE: null,
        flatDiscountValue: ['', [Validators.required]],
        radioFlatDiscount: ['', [Validators.required]],
        TAXABLE: ['', [Validators.required]],
        NONTAXABLE: ['', [Validators.required]],
        ROUNDOFF: ['', [Validators.required]],
        NETAMNT: ['', [Validators.required]],
        ITEMTYPE: [''],
        RECEIVEDTYPE: [''],
        WAREHOUSE: [''],
        TRNAC: [''],
        SettleMode: [''],
        JobID: [''],
        REMARKS: [''],
        WARRANTY: [''],
        ENGINE: [''],
        MODEL: [''],
        VEHNO: [''],
        CUSNAME: [''],
      });

      if (!!this._activatedRoute.snapshot.params['mode']) {
        if (this._activatedRoute.snapshot.params['mode'] == 'view') {
          // this.viewMode = true;
          // this.form.get('MENUCODE').disable();
          // this.form.get('JobID').disable();
          // this.form.get('remarks').disable();
          // this.form.get('selectedProd').disable();
          // this.form.get('Quantity').disable();
        }
      }
      // this.mode="Add";

      if (!!this._activatedRoute.snapshot.params['vchr']) {
        let Initial: any;
        Initial = this._activatedRoute.snapshot.params['vchr'];
        console.log('vchr', Initial);

        this.masterService.getSelectedDeliveryOut(Initial).subscribe(
          (data: any) => {
            if (data.status == 'ok') {
              // this.form.patchValue({
              //     JobID:data.result.jobCode,
              // })
              this.mainVchr = {
                vchrno: data.result.vchrno,

                entrydate: data.result.trndate,
                entrymiti: data.result.bsdate,
              };
              console.log({ returnedTrnmainObj: data.result });
              this.TrnMainObj.VCHRNO = data.result.vchrno;
              this.TrnMainObj.DIVISION = data.result.division;
              this.TrnMainObj.TRNDATE = data.result.trndate;
              this.TrnMainObj.BSDATE = data.result.bsdate;
              this.TrnMainObj.JobCode = data.result.jobCode;
              this.TrnMainObj.TOTAMNT = data.result.totamnt;
              this.TrnMainObj.VATAMNT = data.result.vatamnt;
              this.TrnMainObj.NETWITHOUTROUNDOFF =
                data.result.netwithoutroundoff;
              this.TrnMainObj.TAXABLE = data.result.taxable;
              this.TrnMainObj.NONTAXABLE = data.result.nontaxable;
              this.TrnMainObj.ROUNDOFF = data.result.roundoff;
              this.TrnMainObj.NETAMNT = data.result.netamnt;

              this.selectedJobNo = this.TrnMainObj.JobCode;
              let prodlist = data.result.prodList;
              if (this.TrnMainObj.ProdList == null) {
                this.TrnMainObj.ProdList = [];
              }
              for (let i of prodlist) {
                let prodObj: any = <any>{};
                prodObj.MENUCODE = i.menucode;
                prodObj.ITEMDESC = i.itemdesc;
                prodObj.RATE = i.rate;
                prodObj.Quantity = i.quantity;
                prodObj.AMOUNT = i.amount;
                prodObj.DISCOUNT = i.discount;
                prodObj.VAT = i.vat;
                prodObj.NETAMOUNT = i.netamount;

                this.TrnMainObj.ProdList.push(prodObj);
              }

              if (this._activatedRoute.snapshot.params['mode'] == 'edit') {
                this.modeTitle = 'Edit DeliveryOut';
              } else if (
                this._activatedRoute.snapshot.params['mode'] == 'view'
              ) {
                this.modeTitle = 'View DeliveryOut';
                // this.mode="view"
              }
              this.onAfterMainLoad.emit(this.mainVchr);
              // this.mode = 'edit';
            } else {
              this.mode = '';
              this.modeTitle = 'Edit -Error in Schedule';
              // this.initialTextReadOnly = true;
            }
          },
          (error: any) => {
            this.mode = '';
            this.modeTitle = 'Edit2 -Error in Schedule';
            // this.masterService.resolveError(error, "Schedule - getSchedule");
          }
        );
      }

      if (
        this.TrnMainObj.VoucherType == VoucherTypeEnum.StockIssue ||
        this.TrnMainObj.VoucherType == VoucherTypeEnum.OpeningStockBalance
      ) {
        this.showDiscount = false;
      }
      //this.dropListItem('par');
      if (
        this.TrnMainObj.VoucherType == VoucherTypeEnum.TaxInvoice ||
        this.TrnMainObj.VoucherType == VoucherTypeEnum.Sales ||
        this.TrnMainObj.VoucherType == VoucherTypeEnum.SalesReturn ||
        this.TrnMainObj.VoucherType == VoucherTypeEnum.CreditNote ||
        this.TrnMainObj.VoucherType == VoucherTypeEnum.Purchase ||
        this.TrnMainObj.VoucherType == VoucherTypeEnum.PurchaseReturn ||
        this.TrnMainObj.VoucherType == VoucherTypeEnum.DebitNote
      ) {
        this.deliverytype = false;
      } else {
        this.deliverytype = true;
      }
      this.isEnter = false;
      this.masterService.OpenFlagVehicle().subscribe((data: any) => {
        this.JobList.push(data);
      });
      // this.form.patchValue({
      //     WARRANTY:0
      // })
      let a = this.masterService.TrnObj._id;
      this.form.patchValue({
        JobID: a == null ? null : a,
      });
    } catch (ex) {}
    // this.PList = [];
    console.log({ productInsertonInitTrnmainObj: this.TrnMainObj });
  }

  //To implement javascript
  ngAfterViewInit() {
    //console.log({ onAfterMainLoad: this.mainVchr, trnmain: this.TrnMainObj });
    // // var tableId:string= this.prodlistTable.nativeElement.id;
    // // var scTable=new UltimateScrollingTable(tableId,500,1000,0);
    // //jQuery('#fix').addClass('table-fixed');
    // jQuery(this.prodlistTable.nativeElement).each(function(){
    //     let lst=jQuery(this);
    //     // lst.css("background-color","yellow");
    //     // lst.fixTableHeader();
    // })
    // jQuery(this.prodlistTable.nativeElement).fixTableHeader({fixHeader:true,fixFooter:true});
    // //$('#fixtable').met;
  }

  //autocoplete functions
  search(event: any) {
    if (event.query == '') {
      this.results = this.dropListItem('a');
      return;
    }
    this.results = this.dropListItem(event.query);
  }

  handleDropdownClick(event: any) {
    alert('reached Dropdown handle');
  }

  checkQuantity(qty: string, selectItem: Item) {
    if (
      this.TrnMainObj.VoucherType == VoucherTypeEnum.CreditNote ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.SalesReturn
    ) {
      if (Number(qty) != NaN) {
        if (+qty > selectItem.QUANTITY) {
        }
      }
    }
  }
  // this.results = new Observable((observer: Subscriber<Array<Item>>) => {
  //     let sub10 = this.masterService.getProductItemList()
  //         .subscribe(data => {
  //             setTimeout(() => {
  //                 observer.next(data);
  //             }, 100)

  //         },
  //         Error => {
  //             this.masterService.resolveError(Error, 'Productinsert-handledropdown');
  //         }
  //         );

  // })

  onIFocus(event: any) {
    if (event.target.value == '') return;
    this.search({ query: event.target.value });
  }
  //------autocomplete functions
  //function to get the products list
  AllItemList: any[] = [];
  JobdropListItem = (keyword: any): Observable<Array<any>> => {
    return new Observable((observer: Subscriber<Array<any>>) => {
      let sub11 = this.masterService
        .getJobDescription()
        .pipe(
          map((fList: any) => {
            this.AllItemList = [];
            this.AllItemList.push(fList);
            return fList.filter((data: any) =>
              data.itemName == null
                ? ''
                : data.itemName.toUpperCase().indexOf(keyword.toUpperCase()) >
                  -1
            );
          })
        )
        .pipe(map((res: any) => res.slice(0, 20)))
        .subscribe(
          (data: any) => {
            observer.next(data);
          },
          (Error: any) => {
            observer.complete();
          },
          () => {
            observer.complete();
          }
        );
      this.subscriptions.push(sub11);
    });
  };

  vehobj: any;
  EnterNo($event: any) {
    var value = $event;
    if ($event != null && $event != '') {
      if (this.selectedJob != null) {
        this.productForm.patchValue({
          UNIT: this.selectedJob.units,
          RATE: this.selectedJob.rate,
          AMOUNT: this.selectedJob.amount,
          DISCOUNT: this.selectedJob.discount,
          MENUCODE: this.selectedJob.itemCode,
        });
        this.warranty = this.w;
        console.log('aaa', this.warranty);
      }
    }
  }
  MenuItem: any;
  MenuItemList: any[] = [];
  MList: any[] = [];
  dropListItem = (keyword: any): Observable<Array<Item>> => {
    return new Observable((observer: Subscriber<Array<Item>>) => {
      // let getProduct = this.masterService.getProductItemList();
      let getDispatchOutPList;
      let sub11 = this.masterService
        .getProductItemList()
        .pipe(
          map((counterFilter: any) => {
            if (
              this.TrnMainObj.VoucherType == VoucherTypeEnum.Sales ||
              this.TrnMainObj.VoucherType == VoucherTypeEnum.TaxInvoice
            ) {
              if ((this._trnMainService.salesMode = 'counter')) {
                var filteredList = counterFilter.filter((item: any) =>
                  this.WarehouseWiseCounterMProduct.some(
                    (f) => f.PRODUCT == item.MGROUP
                  )
                );
                return filteredList;
              }
            }
            return counterFilter;
          })
        )
        .pipe(
          map((fList: any) => {
            return fList.filter((data: Item) =>
              data.DESCA == null
                ? ''
                : data.DESCA.toUpperCase().indexOf(keyword.toUpperCase()) > -1
            );
          })
        )
        .pipe(map((res: any) => res.slice(0, 20)))
        .subscribe(
          (data: any) => {
            observer.next(data);
          },
          (Error: any) => {
            this.masterService.resolveError(
              Error,
              'Product Insert - getProductItemList'
            );
            //this.masterService._itemListObservable$ = null;
            observer.complete();
          },
          () => {
            observer.complete();
          }
        );
      this.subscriptions.push(sub11);
    });
  };

  codedropListItem = (keyword: any): Observable<Array<Item>> => {
    return new Observable((observer: Subscriber<Array<Item>>) => {
      // let getProduct = this.masterService.getProductItemList();
      let getDispatchOutPList;
      let sub11 = this.masterService
        .getProductItemList()
        .pipe(
          map((counterFilter: any) => {
            console.log('code drop down list', counterFilter);
            if (
              this.TrnMainObj.VoucherType == VoucherTypeEnum.Sales ||
              this.TrnMainObj.VoucherType == VoucherTypeEnum.TaxInvoice
            ) {
              if ((this._trnMainService.salesMode = 'counter')) {
                var filteredList = counterFilter.filter((item: any) =>
                  this.WarehouseWiseCounterMProduct.some(
                    (f) => f.PRODUCT == item.MGROUP
                  )
                );
                return filteredList;
              }
            }
            return counterFilter.result;
          })
        )
        .pipe(
          map((fList: any) => {
            return fList.filter((data: Item) =>
              data.MENUCODE == null
                ? ''
                : data.MENUCODE.toUpperCase().indexOf(keyword.toUpperCase()) >
                  -1
            );
          })
        )
        .pipe(map((res: any) => res.slice(0, 20)))
        .subscribe(
          (data: any) => {
            observer.next(data);
          },
          (Error: any) => {
            this.masterService.resolveError(
              Error,
              'Product Insert - getProductItemList'
            );
            //this.masterService._itemListObservable$ = null;
            observer.complete();
          },
          () => {
            observer.complete();
          }
        );
      this.subscriptions.push(sub11);
    });
  };

  ngOnInit() {
    //this.masterService.getProductList().subscribe(res=>{this.ItemList.push(<Item>res); });

    // this.itemTypeList = this._trnMainService.getItemType();
    // this.receivedTypeList = this._trnMainService.getReceivedType();
    this.checkValidity();

    if (this.TrnMainObj.Mode == 'VIEW') {
      this.productForm.get('BC')?.disable();
      this.productForm.get('MENUCODE')?.disable();
      this.productForm.get('selectedProd')?.disable();
      this.productForm.get('SelectedAltUnit')?.disable();
      this.productForm.get('RATE')?.disable();
      this.productForm.get('Quantity')?.disable();
      this.productForm.get('IndDiscountValue')?.disable();
      this.productForm.get('EXPDATE')?.disable();
      this.productForm.get('flatDiscountValue')?.disable();
      this.productForm.get('radioIndDiscount')?.disable();
      this.productForm.get('radioFlatDiscount')?.disable();
      this.productForm.get('ITEMTYPE')?.disable();
      this.productForm.get('RECEIVEDTYPE')?.disable();
    }
    // this.productForm.get('AMOUNT').disable();
    // this.productForm.get('TAXABLE').disable();
    // this.productForm.get('NONTAXABLE').disable();
    // this.productForm.get('NETAMNT').disable();
    // this.productForm.get('ROUNDOFF').disable();
    // this.productForm.get('JobID').disable();
    // this.productForm.get('MENUCODE').disable();
    // this.productForm.get('selectedProd').disable();
    this.productForm.patchValue({ radioIndDiscount: '%' });
    this.productForm.patchValue({ radioFlatDiscount: '%' });
    if (this.TrnMainObj.Mode == 'EDIT' || this.TrnMainObj.Mode == 'VIEW') {
      var sub3 = this._trnMainService.loadDataObservable.subscribe(
        (data: any) => {
          try {
            this.TrnMainObj.ProdList = data.ProdList;
            for (let p of this.TrnMainObj.ProdList) {
              p.TOTAL = p.AMOUNT - this.nullToZeroConverter(p.INDDISCOUNT);
            }
            this.productForm.patchValue({
              flatDiscountValue: data.TOTALFLATDISCOUNT,
              ROUNDOFF: data.ROUNDOFF,
            });
            this.CalculateNormal();
            this.ReCalculateBill();
          } catch (e) {}
        }
      );
      this.subscriptions.push(sub3);
    }

    this.renderer.listen(this.quantityBox.nativeElement, 'wheel', (event) => {
      event.returnValue = false;
    });
    this.renderer.listen(this.rateBox.nativeElement, 'wheel', (event) => {
      event.returnValue = false;
    });
    this.renderer.listen(this.discountBox.nativeElement, 'wheel', (event) => {
      event.returnValue = false;
    });
  }

  discountLeftMinHeight() {
    if (this.showDiscount == true) {
      return '211px';
    } else {
      return '159px';
    }
  }

  TableRowDoubleClickEvent(tp: TrnProd, index: any) {
    if (this.TrnMainObj.Mode != 'VIEW') {
      this.TrnProdObj = Object.assign({}, tp);
      this.selectedProd = this.masterService.itemList.find(
        (x) => x.MCODE === tp.MCODE
      );
      this.MCODE = tp.MCODE;
      this.warranty = tp.Warranty;
      this.productForm.patchValue({
        // BC: tp.BC,
        selectedProd: tp.ITEMDESC,
        MENUCODE: tp.MENUCODE,
        RATE: tp.RATE,
        Quantity: tp.Quantity,
        // EXPDATE: this.TrnProdObj.EXPDATE,
        ITEMTYPE: tp.ITEMTYPE,
      });
      this.TrnMainObj.ProdList.splice(index, 1);
      this.ReCalculateBill();
    }

    /*this.masterService.getProductForTran(tp.MCODE).subscribe(data => {
        if (data.status == 'ok') {
            this.selectedItem = <any>data.result;
            
            this.SelectedAltUnit = this.selectedItem.AlternateUnits.filter(x => x.ALTUNIT == tp.UNIT)[0];
 
            this.AltUnitChange(null);
 
            this.TrnProdObj.BC = this.selectedProd.BARCODE;
            this.TrnProdObj.ITEMDESC = this.selectedProd.DESCA;
            this.TrnProdObj.MENUCODE = this.selectedProd.MENUCODE;
            this.TrnProdObj.ISSERVICECHARGE = this.selectedItem.HASSERVICECHARGE;
            this.TrnProdObj.ISVAT = this.selectedProd.ISVAT;
            this.TrnProdObj.RATE=tp.RATE;
            this.TrnProdObj.Quantity=tp.Quantity;
            this.CalculateNormal();
            
        }
    });*/
  }

  // TableRowDoubleClickEvent(tp: TrnProd, index) {
  //     if (this.TrnMainObj.Mode != "VIEW") {
  //         this.TrnProdObj = Object.assign({}, tp);
  //         this.selectedProd = this.masterService.itemList.find(x => x.MCODE === tp.MCODE);
  //         this.itemSelectionChanged(tp.MCODE).subscribe(ret => {
  //             if (ret == true) {
  //                 this.TrnProdObj.BC = this.selectedProd.BARCODE;
  //                 this.TrnProdObj.ITEMDESC = this.selectedProd.DESCA;
  //                 this.TrnProdObj.MENUCODE = this.selectedProd.MENUCODE;
  //                 this.TrnProdObj.ISSERVICECHARGE = this.selectedItem.HASSERVICECHARGE;
  //                 this.TrnProdObj.ISVAT = this.selectedProd.ISVAT;
  //                 this.TrnProdObj.RATE = tp.RATE;
  //                 this.TrnProdObj.Quantity = tp.Quantity;
  //                 this.productForm.patchValue({
  //                     BC: this.TrnProdObj.BC,
  //                     selectedProd: this.TrnProdObj.ITEMDESC,
  //                     MENUCODE: this.TrnProdObj.MENUCODE,
  //                     RATE: this.TrnProdObj.RATE,
  //                     Quantity: this.TrnProdObj.Quantity,
  //                     EXPDATE: this.TrnProdObj.EXPDATE,
  //                     ITEMTYPE: this.TrnProdObj.ITEMTYPE,
  //                     RECEIVEDTYPE: this.TrnProdObj.RECEIVEDTYPE,
  //                 });
  //                 this.CalculateNormal();
  //                 if (tp.IDIS != null) {
  //                     if (tp.IDIS.indexOf("%") < 0) {
  //                         this.IndDiscountValue = parseFloat(this.TrnProdObj.IDIS);
  //                         this.radioIndDiscount = "amt";
  //                         this.productForm.patchValue({
  //                             IndDiscountValue: this.IndDiscountValue,
  //                             radioIndDiscount: this.radioIndDiscount
  //                         });
  //                     }
  //                     else {
  //                         this.IndDiscountValue = parseFloat(tp.IDIS.replace("%", "").trim());
  //                         this.radioIndDiscount = "%";
  //                         this.productForm.patchValue({
  //                             IndDiscountValue: this.IndDiscountValue,
  //                             radioIndDiscount: this.radioIndDiscount
  //                         });
  //                     }
  //                 }
  //                 this.TrnMainObj.ProdList.splice(index, 1);
  //                 this.ReCalculateBill();
  //             }
  //         })
  //     }

  //     /*this.masterService.getProductForTran(tp.MCODE).subscribe(data => {
  //         if (data.status == 'ok') {
  //             this.selectedItem = <any>data.result;

  //             this.SelectedAltUnit = this.selectedItem.AlternateUnits.filter(x => x.ALTUNIT == tp.UNIT)[0];

  //             this.AltUnitChange(null);

  //             this.TrnProdObj.BC = this.selectedProd.BARCODE;
  //             this.TrnProdObj.ITEMDESC = this.selectedProd.DESCA;
  //             this.TrnProdObj.MENUCODE = this.selectedProd.MENUCODE;
  //             this.TrnProdObj.ISSERVICECHARGE = this.selectedItem.HASSERVICECHARGE;
  //             this.TrnProdObj.ISVAT = this.selectedProd.ISVAT;
  //             this.TrnProdObj.RATE=tp.RATE;
  //             this.TrnProdObj.Quantity=tp.Quantity;
  //             this.CalculateNormal();

  //         }
  //     });*/

  // }

  //barcode change event
  barcodeChange(value: any) {
    this.Barcodes = [];
    this.SelectedBcode = <any>{};
    //this.CommonService.GetProductFromBarcode(value).then(result => { });
    if (value == null || value == '') return;
    var sub3 = this.masterService
      .getBarcodeWiseProductForTran(value)
      .subscribe((res: any) => {
        this.Barcodes.push(<any>res);
        if (this.Barcodes[0].BCODE == 'invalid') {
          this.TrnProdObj = <TrnProd>{};
        } else {
          if (this.Barcodes.length > 1) {
            this.MultiBCode.show();
          } else {
            this.SelectedBcode = this.Barcodes[0];
          }
          if (this.SelectedBcode != null) {
            // this.itemSelectionChanged(this.SelectedBcode.MCODE)
            // this.selectedItemChange(this.SelectedBcode);
            // this.TrnProdObj.MCODE = this.SelectedBcode.MCODE;
            // this.TrnProdObj.BC = this.SelectedBcode.BCODE;
          }
        }
      });
    //this.subscriptions.push(sub3);
  }
  MultiBarcodeOkClick(value: any) {
    if (value != null) {
      this.SelectedBcode = value;
      this.MultiBCode.hide();
      this.selectedItemChange(this.SelectedBcode);
      this.TrnProdObj.MCODE = this.SelectedBcode.MCODE;
      this.TrnProdObj.BC = this.SelectedBcode.BCODE;
    }
  }

  AltUnitChange(value: any) {
    this.TrnProdObj.UNIT = this.SelectedAltUnit.ALTUNIT;
    this.productForm.patchValue({ UNIT: this.SelectedAltUnit.ALTUNIT });
    if (
      this.TrnMainObj.VoucherType == VoucherTypeEnum.Purchase ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.PurchaseReturn ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.DebitNote ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.BranchTransferOut ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.BranchTransferIn ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.StockIssue
    ) {
      this.TrnProdObj.RATE = this.SelectedAltUnit.PRATE;
      this.productForm.patchValue({ RATE: this.SelectedAltUnit.PRATE });
    } else {
      this.TrnProdObj.RATE = this.SelectedAltUnit.RATE;
      this.productForm.patchValue({ RATE: this.SelectedAltUnit.RATE });
    }
    this.TrnProdObj.REALRATE =
      this.SelectedAltUnit.CONFACTOR * this.TrnProdObj.RATE;

    this.CalculateNormal();
  }

  //event fire when item is selected
  selectedItemChange(value: any) {
    let item =
      this.masterService.itemList.find((x) => x.MENUCODE == value) ?? null;
    var sub1 = this.masterService
      .getProductForTran(item?.MCODE ?? '')
      .subscribe((data: any) => {
        if (data.status == 'ok') {
          this.selectedItem = <any>data.result;
          if (
            this.selectedItem.AlternateUnits != null &&
            this.selectedItem.AlternateUnits.length > 0
          ) {
            this.SelectedAltUnit = this.selectedItem.AlternateUnits[0];
            this.productForm.patchValue({
              SelectedAltUnit: this.selectedItem.AlternateUnits[0],
            });
            this.AltUnitChange(null);
          }
          this.TrnProdObj.ALTUNIT = this.selectedItem.BASEUNIT;
          // if (BCodeWise == false) {
          //     this.TrnProdObj.BC = this.selectedItem.BARCODE;
          // }
          this.TrnProdObj.ITEMTYPE = this.selectedItem.ITEMTYPE;
          this.TrnProdObj.HASITEMTYPE = this.selectedItem.HASITEMTYPE;
          this.TrnProdObj.ITEMDESC = this.selectedItem.DESCA;
          this.TrnProdObj.MENUCODE = this.selectedItem.MENUCODE;
          this.TrnProdObj.ISSERVICECHARGE = this.selectedItem.HASSERVICECHARGE;
          // alert("reached VAT 2")
          this.TrnProdObj.ISVAT = this.selectedItem.VAT;
          this.TrnProdObj.PRATE = this.selectedItem.PRATE;
        }
      });
    //this.subscriptions.push(sub1);
    this.TrnProdObj.PROMOTION = 0;
    this.TrnProdObj.LOYALTY = 0;
    this.TrnProdObj.INDDISCOUNT = 0;
  }

  menucodeChanged(value: any) {
    //event.stopPropagation();
    var item = this.masterService.itemList.find((x) => x.MENUCODE == value);
    this.selectedProd = '';
    if (item) {
      value = item.MCODE;
      this.TrnProdObj.MCODE = item.MCODE;
      this.productForm.patchValue({
        selectedProd: item.DESCA,
        RATE: item.RATE,
      });

      // this.itemChanged(value);
      this.TrnProdObj.RATE = this.productForm.value.RATE;
      this.TrnProdObj.MENUCODE = item.MENUCODE;
      this.TrnProdObj.ITEMDESC = item.DESCA;

      this.selectedProd = item;
    } else {
      // value = undefined;
    }
    //this.itemSelectionChanged(value);
  }
  MCODE: any;
  itemChanged(value: any) {
    this.itemQty = value;
    console.log(this.itemQty, 'newwww');

    if (value == null || value == undefined) {
      return;
    }
    // for selecting non-warranty as default

    // if (typeof (value) === 'object' && this.warrantyURL === '/pages/inventory/dispatch') {
    //   this.warranty = '1';
    // }
    //  else {
    //   this.warranty = '0';
    // }

    // for patching values in non warranty and warranty

    //   if (typeof (value) === 'object'  && this.warrantyURL === '/pages/inventory/dispatchIn' ) {
    //     var deep = _.cloneDeep(value);
    //     this.warranty = deep.warranty;
    // }
    if (typeof value === 'object') {
      if (this.warrantyURL === '/pages/inventory/dispatch') {
        this.warranty = '0';
      } else {
        this.warranty = '1';
      }
      if (this.warrantyURL === '/pages/inventory/dispatchIn') {
        var deep = _.cloneDeep(value);
        this.warranty = deep.warranty;
        console.log(this.warranty, 'deep warranty');
      }
    }
    this.selectedProd = '';
    if (typeof value === 'object') {
      this.masterService.getDetailsFromMcode(value).subscribe((data: any) => {
        console.log(data.result.mcode, 'resulttt');
        this.mcode = data.result.mcode;
        this.TrnProdObj = <any>{};
        this.TrnProdObj.ITEMDESC = data.result.desca;
        this.TrnProdObj.RATE = data.result.ratE_A;
        this.TrnProdObj.MENUCODE = data.result.menucode;
        this.TrnProdObj.MCODE = this.MCODE = data.result.mcode;
        //this.TrnProdObj.EXPDATE=data.result.expdate;
        // this.TrnProdObj.DISCOUNT=data.result.DISAMOUNT;
        if (this.masterService.DispatchName == 'DispatchIn') {
          for (let i of this.PList) {
            //PList comes when we enter JOBID
            if (this.TrnProdObj.MENUCODE == i.MENUCODE) {
              //TrnProdObj is the item we selected
              this.productForm.patchValue({
                //Auto Patch value of Quantity and Discount for Delivery In
                Quantity: i.Quantity,
                IndDiscountValue: i.INDDISCOUNT,
                EXPDATE: i.EXPDATE,
                radioIndDiscount: 'amt',
              });
              if (i.quantity != 0) {
                this.txtQuantityChange(i.discount);
              }
            }
          }
        }
        this.productForm.patchValue({
          MENUCODE: this.TrnProdObj.MENUCODE,
          RATE: this.TrnProdObj.RATE,
          selectedProd: this.TrnProdObj.ITEMDESC,
          // Quantity: this.TrnProdObj.Quantity,
          // EXPDATE: this.TrnProdObj.EXPDATE,
          //  ITEMTYPE: this.TrnProdObj.ITEMTYPE,
          //   RECEIVEDTYPE: this.TrnProdObj.RECEIVEDTYPE,
          //   IndDiscountValue:this.TrnProdObj.DISCOUNT,
        });
        // this.form.patchValue({

        // })
        // this.changedate(data.result.licence_expdate.substring(0, 10), "AD", "LicenceExp");
      });
    }

    for (let a of this.sumList) {
      if (a.MCODE == this.mcode) {
        this.warranty = a.Warranty;
      }
    }

    // if (typeof (value) === 'object') {
    //     this.TrnProdObj = <TrnProd>{};
    //     this.itemSelectionChanged(value.MCODE);

    // }
  }

  // itemChanged(value: any) {

  //     if (typeof (value) === 'object') {
  //         this.TrnProdObj = <TrnProd>{};
  //         this.itemSelectionChanged(value.MCODE).subscribe(ret => {
  //             if (ret == true) {
  //                 this.SelectedAltUnit = this.selectedItem.AlternateUnits[0];
  //                 this.productForm.patchValue({ SelectedAltUnit: this.selectedItem.AlternateUnits[0] });
  //                 this.productForm.patchValue({ MENUCODE: this.TrnProdObj.MENUCODE });
  //             }
  //         })

  //     }

  // }

  itemSelectionChanged(MCODE: string) {
    //don't do anything if value is null or undefined
    this.selectedItem = '';
    this.TrnProdObj = <TrnProd>{};
    if (MCODE === undefined || MCODE == null) {
      return;
    }
    this.getProductFromDatabase(MCODE).subscribe(
      (data: any) => {
        this.productForm.patchValue({
          BC: this.TrnProdObj.BC,
          //selectedProd: this.TrnProdObj.ITEMDESC,
          MENUCODE: this.TrnProdObj.MENUCODE,
          RATE: this.TrnProdObj.RATE,
          Quantity: this.TrnProdObj.Quantity,
          EXPDATE: this.TrnProdObj.EXPDATE,
          ITEMTYPE: this.TrnProdObj.ITEMTYPE,
          RECEIVEDTYPE: this.TrnProdObj.RECEIVEDTYPE,
        });
        this.CalculateNormal();
      },
      (Error: any) => {
        this.selectedItem = '';
        this.TrnProdObj = <TrnProd>{};
        this.masterService.resolveError(
          Error,
          'Product Insert - getProductForTran'
        );
      }
    );
    this.previousOpeningStockData = [];
    if (this.voucherType == VoucherTypeEnum.OpeningStockBalance) {
      this.getPreviousAccountOpeningBalance(MCODE);
    }
    //this.subscriptions.push(sub);
  }
  // this.TrnProdObj.PROMOTION = 0;
  // this.TrnProdObj.LOYALTY = 0;
  // this.TrnProdObj.INDDISCOUNT = 0;

  getProductFromDatabase(MCODE: any) {
    return this.masterService.getProductForTran(MCODE).pipe(
      map((data: any) => {
        if (data.status == 'ok') {
          this.selectedItem = <any>data.result;
          if (
            this.selectedItem.AlternateUnits != null &&
            this.selectedItem.AlternateUnits.length > 0
          ) {
            this.SelectedAltUnit = this.selectedItem.AlternateUnits[0];
            this.productForm.patchValue({
              SelectedAltUnit: this.selectedItem.AlternateUnits[0],
            });
            this.AltUnitChange(null);

            //this.TrnProdObj.UNIT = this.SelectedAltUnit.BASEUNIT;
            this.TrnProdObj.ALTUNIT = this.selectedItem.BASEUNIT;
            this.TrnProdObj.BC = this.selectedItem.BARCODE;
            this.TrnProdObj.ITEMDESC = this.selectedItem.DESCA;
            this.TrnProdObj.MENUCODE = this.selectedItem.MENUCODE;
            this.TrnProdObj.MCODE = this.selectedItem.MCODE;
            this.TrnProdObj.HASITEMTYPE = this.selectedItem.HASITEMTYPE;
            this.TrnProdObj.ISSERVICECHARGE =
              this.selectedItem.HASSERVICECHARGE;
            this.TrnProdObj.Ptype = this.selectedItem.PTYPE;
            /* below is written n altunitchange
                if (this.TrnMainObj.VoucherType == VoucherTypeEnum.Purchase || this.TrnMainObj.VoucherType==VoucherTypeEnum.PurchaseReturn || this.TrnMainObj.VoucherType==VoucherTypeEnum.DebitNote || this.TrnMainObj.VoucherType== VoucherTypeEnum.BranchTransferOut || this.TrnMainObj.VoucherType == VoucherTypeEnum.BranchTransferIn || this.TrnMainObj.VoucherType==VoucherTypeEnum.StockIssue) {
                this.TrnProdObj.RATE = this.selectedItem.PRATE_A;
            } else {
                this.TrnProdObj.RATE = this.selectedItem.RATE_A;
            }*/
            alert('reached VAT 3');
            this.TrnProdObj.ISVAT = this.selectedItem.VAT;
            this.TrnProdObj.PRATE = this.selectedItem.PRATE;
            return true;
          }
          return false;
        } else {
          return false;
        }
      })
    );
  }

  // itemSelectionChanged(MCODE: string) {
  //     // mcode = this.masterService.itemList.find(this.selectedItem.mcode)

  //     //don't do anything if value is null or undefined
  //     return new Observable((observer: Subscriber<boolean>) => {

  //         if (MCODE === undefined || MCODE == null) {

  //             this.selectedItem = "";
  //             this.TrnProdObj = <TrnProd>{};
  //             observer.next(false);
  //         }
  //         var sub = this.masterService.getProductForTran(MCODE).subscribe(data => {
  //             if (data.status == 'ok') {
  //                 this.selectedItem = <any>data.result;
  //                 if (this.selectedItem.AlternateUnits != null && this.selectedItem.AlternateUnits.length > 0) {
  //                     this.SelectedAltUnit = this.selectedItem.AlternateUnits[0];
  //                     this.productForm.patchValue({ SelectedAltUnit: this.selectedItem.AlternateUnits[0] });
  //                     this.AltUnitChange(null);

  //                     //this.TrnProdObj.UNIT = this.SelectedAltUnit.BASEUNIT;
  //                     this.TrnProdObj.ALTUNIT = this.selectedItem.BASEUNIT;
  //                     this.TrnProdObj.BC = this.selectedItem.BARCODE;
  //                     this.TrnProdObj.ITEMDESC = this.selectedItem.DESCA;
  //                     this.TrnProdObj.MENUCODE = this.selectedItem.MENUCODE;
  //                     this.TrnProdObj.MCODE = this.selectedItem.MCODE;
  //                     this.TrnProdObj.HASITEMTYPE = this.selectedItem.HASITEMTYPE;
  //                     // if (this.TrnMainObj.VoucherType == 'PI') {
  //                     //     this.TrnProdObj.RATE = this.selectedItem.PRATE;
  //                     // } else {
  //                     //     this.TrnProdObj.RATE = this.selectedItem.RATE;
  //                     // }

  //                     //this.TrnProdObj.ISSERVICECHARGE = this.selectedItem.HASSERVICECHARGE;
  //                     this.TrnProdObj.ISVAT = this.selectedItem.VAT;
  //                     observer.next(true);
  //                 }

  //             }
  //             else {
  //                 observer.next(false);
  //             }
  //         }, Error => {
  //             observer.next(false);
  //             this.masterService.resolveError(Error, "Product Insert - getProductForTran");
  //         });
  //         //this.subscriptions.push(sub);
  //     })
  //     // this.TrnProdObj.PROMOTION = 0;
  //     // this.TrnProdObj.LOYALTY = 0;
  //     // this.TrnProdObj.INDDISCOUNT = 0;

  // }

  //event fire when quantity is changes
  txtQuantityChange(value: any) {
    this.TrnProdObj.Quantity = this.productForm.value.Quantity;
    this.CalculateNormal();
  }
  //event fire when rate is changes
  txtRateChange(value: any) {
    this.TrnProdObj.RATE = this.productForm.value.RATE;
    this.CalculateNormal();
  }
  //event fire  when txtdiscount or radio button of individual discount is changes
  IndDiscountChange() {
    if (this.productForm.value.IndDiscountValue == null) {
      this.productForm.value.IndDiscountValue = 0;
    }
    if (
      this.productForm.value.IndDiscountValue != null &&
      this.productForm.value.radioIndDiscount != null
    ) {
      if (parseFloat(this.productForm.value.IndDiscountValue) < 0) {
        this.productForm.patchValue({ IndDiscountValue: 0 });
      }
      if (this.productForm.value.radioIndDiscount == '%') {
        if (parseFloat(this.productForm.value.IndDiscountValue) > 100) {
          this.productForm.patchValue({ IndDiscountValue: 100 });
        }
        this.TrnProdObj.IDIS =
          this.nullToZeroConverter(this.productForm.value.IndDiscountValue) +
          '%';
      } else if (this.productForm.value.radioIndDiscount == 'amt') {
        if (this.TrnProdObj.AMOUNT == null || this.TrnProdObj.AMOUNT <= 0) {
          this.productForm.patchValue({ IndDiscountValue: 0 });
        } else if (
          parseFloat(this.productForm.value.IndDiscountValue) >
          this.TrnProdObj.AMOUNT
        ) {
          this.productForm.patchValue({
            IndDiscountValue: this.TrnProdObj.AMOUNT,
          });
        }
        this.TrnProdObj.IDIS = this.nullToZeroConverter(
          this.productForm.value.IndDiscountValue
        ).toString();
      }
      this.CalculateNormal();
    }
  }
  //event fire when txtdiscount or radio button of flat discount is changes
  flatDiscountChange() {
    if (this.productForm.value.flatDiscountValue == null) {
      this.productForm.value.flatDiscountValue = 0;
    }
    if (
      this.productForm.value.flatDiscountValue != null &&
      this.productForm.value.radioFlatDiscount != null &&
      this.TrnMainObj.ProdList != null &&
      this.TrnMainObj.ProdList.length > 0
    ) {
      if (parseFloat(this.productForm.value.flatDiscountValue) < 0) {
        this.productForm.patchValue({ flatDiscountValue: 0 });
      }
      if (this.productForm.value.radioFlatDiscount == '%') {
        if (parseFloat(this.productForm.value.flatDiscountValue) > 100) {
          this.productForm.patchValue({ flatDiscountValue: 100 });
        }
        this.TrnMainObj.DCRATE =
          parseFloat(this.productForm.value.flatDiscountValue) / 100;
        var sum: number = 0;
        if (this.TrnMainObj.ReplaceIndividualWithFlatDiscount == 1) {
          this.TrnMainObj.ProdList.forEach((p) => {
            sum +=
              p.AMOUNT -
              this.nullToZeroConverter(p.PROMOTION) -
              this.nullToZeroConverter(p.LOYALTY);
          });
        } else {
          this.TrnMainObj.ProdList.forEach((p) => {
            sum +=
              p.AMOUNT -
              this.nullToZeroConverter(p.INDDISCOUNT) -
              this.nullToZeroConverter(p.PROMOTION) -
              this.nullToZeroConverter(p.LOYALTY);
          });
        }
        this.TrnMainObj.TOTALFLATDISCOUNT = sum * this.TrnMainObj.DCRATE;
        // this.productForm.patchValue({ flatDiscountValue: (this.TrnMainObj.TOTALFLATDISCOUNT).toString() });
      } else if (this.productForm.value.radioFlatDiscount == 'amt') {
        if (
          parseFloat(this.productForm.value.flatDiscountValue) >
          this.TrnMainObj.NETAMNT
        ) {
          this.productForm.patchValue({ flatDiscountValue: 0 });
        }
        this.TrnMainObj.TOTALFLATDISCOUNT = parseFloat(
          this.productForm.value.flatDiscountValue
        );
        this.productForm.patchValue({
          flatDiscountValue: this.TrnMainObj.TOTALFLATDISCOUNT.toString(),
        });

        var amt: number = 0;
        if (this.TrnMainObj.ReplaceIndividualWithFlatDiscount == 1) {
          this.TrnMainObj.ProdList.forEach((p) => {
            amt +=
              p.AMOUNT -
              this.nullToZeroConverter(p.PROMOTION) -
              this.nullToZeroConverter(p.LOYALTY);
          });
        } else {
          this.TrnMainObj.ProdList.forEach((p) => {
            amt +=
              p.AMOUNT -
              this.nullToZeroConverter(p.INDDISCOUNT) -
              this.nullToZeroConverter(p.PROMOTION) -
              this.nullToZeroConverter(p.LOYALTY);
          });
        }
        if (amt == 0) {
          this.TrnMainObj.DCRATE = 0;
        } else {
          this.TrnMainObj.DCRATE = this.TrnMainObj.TOTALFLATDISCOUNT / amt;
        }
      }
      this.ReCalculateBill();
    }
  }
  //event fire when radio button cash,bank or credit  is changes
  radioTrnModeChange(value: any) {
    if (value == null) return;
    if (value.toString() == 'cash') {
    } else if (value.toString() == 'credit') {
    } else if (value.toString() == 'bank') {
    }
  }
  remarks: any;
  RemarksType() {
    this._trnMainService.TrnMainObj.Remarks = this.remarks;
  }
  onAddClick() {
    console.log({ isReatTimestockcheck: this.enableRealTimeStockCheck });

    if (this.masterService.DispatchName == 'DispatchOut') {
      console.log({
        'first case entered': 1,
        enableRealtimestockcheck: this.enableRealTimeStockCheck,
      });
      if (this.enableRealTimeStockCheck) {
        const menu = this.TrnProdObj.MCODE;
        console.log({ mcode: menu, quantity: this.TrnProdObj.Quantity });
        const q = this.TrnProdObj.Quantity;
        console.log('meqnu', q);
        // this.getStockCheck(menu, q);

        this.masterService.getStockCheck(menu, q, this.inputVchrType).subscribe(
          (response: any) => {
            const res = response;
            if (res && res.status === 'ok') {
              this.addStock();
            } else if (res && res.status === 'error') {
              this.DialogMessage = res.result;
              this.childModal.show();
              setTimeout(() => {
                this.childModal.hide();
              }, 2000);
            }
          },
          (error: any) => {
            alert(
              'Realtime stockcheck enabled but problem in network connection'
            );
          }
        );
      } else {
        this.addStock();
        console.log('stock entered');
      }
      this.genericGridJCList.focusAnyControl('MENUCODE');
    } else {
      console.log('stock entered');
      this.addStock();
      console.log('stock entered');
    }
  }

  checkValidity() {
    console.log('check validity', this.selectedJobNo);
    if (this.selectedJobNo == null || this.selectedJobNo == '') {
      console.log('SelectedJob', this.selectedJobNo);
      //  this.productForm.get('MENUCODE').disable() : this.productForm.get('MENUCODE').enable();
      this.productForm.controls['MENUCODE'].disable();
      this.productForm.controls['Quantity'].disable();
      this.productForm.controls['selectedProd'].disable();
      this.productForm.controls['AMOUNT'].disable();
      this.productForm.controls['RATE'].disable();

      this.productForm.reset();
    } else {
      this.productForm.controls['MENUCODE'].enable();
      this.productForm.controls['selectedProd'].enable();
      this.productForm.controls['Quantity'].enable();
      this.productForm.controls['AMOUNT'].enable();
      this.productForm.controls['RATE'].enable();
    }
  }

  addStock() {
    //    alert("reached")
    this.selectedProd = null;
    this.TrnProdObj.WAREHOUSE = this.productForm.value.WAREHOUSE;

    this.TrnProdObj.TRNAC = this.productForm.value.TRNAC;

    // if (this.TrnProdObj == null || this.TrnProdObj.MCODE == null || (this.productForm.value.Quantity <= 0 && this.voucherType != VoucherTypeEnum.OpeningStockBalance)) return;
    if (this.TrnMainObj.ProdList == null) {
      this.TrnMainObj.ProdList = [];
    }
    var IL = this.TrnMainObj.ProdList.filter(
      (item) => item.MCODE == this.TrnProdObj.MCODE
    );
    if (this.masterService.DispatchName == 'DispatchIn') {
      var mcode = null;
      for (let i of this.result) {
        if (i.ProdList.MENUCODE == this.productForm.value.MENUCODE) {
          mcode = i.ProdList.MCODE;
          console.log('mcode', mcode);
        }
      }
      console.log('qty', this.productForm.value.Quantity);
      for (let i of this.sumList) {
        console.log('summcode', i);

        console.log('entered loop of sumlist');
        if (mcode == i.MCODE) {
          console.log({ mcode: 'mcode', sumRealqty: i.RealQty });

          if (this.productForm.value.Quantity > i.RealQty) {
            this.DialogMessage =
              'Cannot add item. Delivery-out quantity are only ' +
              i.RealQty +
              ' ';
            this.childModal.show();
            setTimeout(() => {
              this.childModal.hide();
            }, 3000);
            return;
          }
        }
      }
      if (IL != null) {
        console.log('IL1', IL);
        if (IL.length > 0) {
          console.log('check1');
          if (IL.filter((x) => x.UNIT == this.TrnProdObj.UNIT).length > 0) {
            this.DialogMessage = 'Product already exist. Cannot add duplicate!';
            this.childModal.show();
            setTimeout(() => {
              this.childModal.hide();
            }, 2000);
          }
        } else {
          this.AddItem();
        }
      }
    } else {
      if (IL != null) {
        console.log('IL2', IL);
        if (IL.length > 0) {
          console.log('check2');
          if (IL.filter((x) => x.UNIT == this.TrnProdObj.UNIT).length > 0) {
            this.DialogMessage = 'Product already exist. Continue anyway?';
            this.lengths = true;
            this.childModal.show();
          }
        } else {
          this.AddItem();
        }
      }
    }
  }

  AddItem() {
    // this.IndDiscountChange();
    // this.CalculateNormal();
    console.log({ warratyvalue: this.warranty });
    this.TrnProdObj.TOTAL =
      this.TrnProdObj.AMOUNT -
      this.nullToZeroConverter(this.TrnProdObj.INDDISCOUNT);
    if (
      this.TrnMainObj.VoucherType == VoucherTypeEnum.Purchase ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.SalesReturn ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.CreditNote ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.BranchTransferIn ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.DeliveryReturn ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.GoodsReceived
    ) {
      this.TrnProdObj.REALQTY_IN =
        this.SelectedAltUnit.CONFACTOR * this.productForm.value.Quantity;
      this.TrnProdObj.ALTQTY_IN = this.productForm.value.Quantity;
      this.TrnProdObj.RealQty = 0;
      this.TrnProdObj.AltQty = 0;
      this.TrnProdObj.VoucherType = this.TrnMainObj.VoucherType;
    } else if (
      this.TrnMainObj.VoucherType == VoucherTypeEnum.Sales ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.PurchaseReturn ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.DebitNote ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.Delivery ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.BranchTransferOut ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.TaxInvoice ||
      this.TrnMainObj.VoucherType == VoucherTypeEnum.StockIssue
    ) {
      //alert("DispatchOut")

      this.TrnProdObj.RealQty =
        this.SelectedAltUnit.CONFACTOR * this.productForm.value.Quantity;
      this.TrnProdObj.AltQty = this.productForm.value.Quantity;
      this.TrnProdObj.REALQTY_IN = 0;
      this.TrnProdObj.ALTQTY_IN = 0;
      this.TrnProdObj.VoucherType = this.TrnMainObj.VoucherType;
      this.TrnProdObj.Warranty = this.warranty;
    } else if (
      this.TrnMainObj.VoucherType == VoucherTypeEnum.OpeningStockBalance
    ) {
      if (this.productForm.value.Quantity > 0) {
        this.TrnProdObj.REALQTY_IN =
          this.SelectedAltUnit.CONFACTOR * this.productForm.value.Quantity;
        this.TrnProdObj.ALTQTY_IN = this.productForm.value.Quantity;
        this.TrnProdObj.RealQty = 0;
        this.TrnProdObj.AltQty = 0;
        this.TrnProdObj.VoucherType = this.TrnMainObj.VoucherType;
      } else if (this.productForm.value.Quantity < 0) {
        this.TrnProdObj.RealQty =
          -1 * this.SelectedAltUnit.CONFACTOR * this.productForm.value.Quantity;
        this.TrnProdObj.AltQty = -1 * this.productForm.value.Quantity;
        this.TrnProdObj.REALQTY_IN = 0;
        this.TrnProdObj.ALTQTY_IN = 0;
        this.TrnProdObj.VoucherType = this.TrnMainObj.VoucherType;
      }
    } else if (
      (this.TrnMainObj.VoucherType = VoucherTypeEnum.StockSettlement)
    ) {
      /*
       none of the value are 0 here
       later while save the value it will checks StockSettlement and then return 0 there.
       */

      if (this.masterService.DispatchName == 'DispatchOut') {
        this.TrnProdObj.REALQTY_IN = 0;
        this.TrnProdObj.ALTQTY_IN = 0;
        this.TrnProdObj.RealQty = this.productForm.value.Quantity;
        3;
        this.TrnProdObj.AltQty = 0;
        this.TrnProdObj.Warranty = this.warranty;
      } else {
        this.TrnProdObj.REALQTY_IN = this.productForm.value.Quantity;
        this.TrnProdObj.ALTQTY_IN = 0;
        this.TrnProdObj.RealQty = 0;
        this.TrnProdObj.AltQty = 0;
        this.TrnProdObj.Warranty = this.warranty;
      }
      // this.TrnProdObj.VoucherType = this.TrnMainObj.VoucherType;
    } else {
      this.DialogMessage =
        this.TrnMainObj.VoucherType + ':VoucherType not found';
      this.childModal.show();
      setTimeout(() => {
        this.childModal.hide();
      }, 3000);
    }
    this.TrnProdObj.NETAMOUNT = this.TrnProdObj.NETAMOUNT * 1.13;
    this.TrnProdObj.VAT =
      this.TrnProdObj.NETAMOUNT - this.TrnProdObj.NETAMOUNT / 1.13;
    this.masterService.TotalAmt = this.TrnProdObj.TOTAL;
    if (this.warranty == 0) this.TrnProdObj.WarrantyStr = 'Non-Warranty';
    else this.TrnProdObj.WarrantyStr = 'Warranty';
    // this.TrnProdObj.EXPDATE = this.productForm.get('EXPDATE').value;
    // this.TrnProdObj.ITEMTYPE = this.productForm.get('ITEMTYPE').value;
    // this.TrnProdObj.RECEIVEDTYPE = this.productForm.get('RECEIVEDTYPE').value || ""
    //clone trnprod to new class
    var newTrnpord = _.cloneDeep(this.TrnProdObj);
    this._trnMainService.TrnMainObj.ProdList.push(newTrnpord);
    // this.TrnMainObj.ProdList.push(this.TrnProdObj);
    // this.flatDiscountValue = 0;
    this.ReCalculateBill();
    // this.TrnProdObj = <TrnProd>{};
    // this.selectedItem = <any>{};
    // this.selectedProd = '';
    // this.IndDiscountValue = 0;
    this.TrnProdObj = <TrnProd>{};
    this.productForm.patchValue({
      // BC: "",
      MENUCODE: '',
      selectedProd: '',
      // SelectedAltUnit: "",
      RATE: '',
      Quantity: '',
      AMOUNT: '',
      IndDiscountValue: '',
      EXPDATE: null,
      // ITEMTYPE: "",
      // RECEIVEDTYPE: "",
    });

    // this.TrnProdObj.Quantity == 0;
    // this.jobValue=null;

    // this.renderer.invokeElementMethod(this.onAddFocus.el.nativeElement, 'focus');
    //this.onAddFocus.el.focus();
  }

  CalculateNormal() {
    try {
      if (
        this.productForm.value.Quantity == null ||
        this.TrnProdObj.RATE == null
      )
        return;
      this.TrnProdObj.AMOUNT =
        this.productForm.value.Quantity * this.TrnProdObj.RATE;
      if (this.AppSettings.ENABLEMULTICURRENCY == 1) {
        this.TrnProdObj.NCRATE = this.curencyConvert(this.TrnProdObj.RATE);
        this.TrnProdObj.EXRATE = this.TrnMainObj.EXRATE;
        this.TrnProdObj.AMOUNT =
          this.productForm.value.Quantity * this.TrnProdObj.NCRATE;
      }
      this.productForm.patchValue({ AMOUNT: this.TrnProdObj.AMOUNT });

      if (this.TrnProdObj.IDIS != null) {
        if (this.TrnProdObj.IDIS.indexOf('%') < 0) {
          this.TrnProdObj.INDDISCOUNT = parseFloat(this.TrnProdObj.IDIS);
        } else {
          var dis = parseFloat(this.TrnProdObj.IDIS.replace('%', '').trim());
          dis = dis / 100;
          this.TrnProdObj.INDDISCOUNT = this.TrnProdObj.AMOUNT * dis;
        }
      }
      this.TrnProdObj.DISCOUNT =
        this.nullToZeroConverter(this.TrnProdObj.INDDISCOUNT) +
        this.nullToZeroConverter(this.TrnProdObj.PROMOTION) +
        this.nullToZeroConverter(this.TrnProdObj.LOYALTY);

      if (this.nullToZeroConverter(this.TrnProdObj.ISSERVICECHARGE) == 1) {
        this.TrnProdObj.SERVICETAX =
          (this.TrnProdObj.AMOUNT - this.TrnProdObj.DISCOUNT) *
          this.ServiceTaxRate;
      }
      // if (this.TrnProdObj.ISVAT == 1) {
      this.TrnProdObj.TAXABLE =
        this.TrnProdObj.AMOUNT -
        this.TrnProdObj.DISCOUNT +
        this.nullToZeroConverter(this.TrnProdObj.SERVICETAX);
      this.TrnProdObj.NONTAXABLE = 0;
      this.TrnProdObj.VAT = this.TrnProdObj.TAXABLE * this.VatRate;
      // this.productForm.patchValue({
      //     TAXABLE: this.TrnProdObj.TAXABLE,
      //     NONTAXABLE: this.TrnProdObj.NONTAXABLE
      // });
      // }
      // else {
      //     alert("reached NonTax")
      //     this.TrnProdObj.TAXABLE = 0;
      //     this.TrnProdObj.NONTAXABLE = (this.TrnProdObj.AMOUNT - this.TrnProdObj.DISCOUNT) + this.nullToZeroConverter(this.TrnProdObj.SERVICETAX);
      //     // this.productForm.patchValue({
      //     //     TAXABLE: this.TrnProdObj.TAXABLE,
      //     //     NONTAXABLE: this.TrnProdObj.NONTAXABLE
      //     // });
      // }
      this.TrnProdObj.NETAMOUNT =
        this.TrnProdObj.TAXABLE +
        this.TrnProdObj.NONTAXABLE +
        this.TrnProdObj.VAT;
    } catch (ex) {}
  }

  ReCalculateBill() {
    this.TrnMainObj.TOTAMNT = 0;
    this.TrnMainObj.ProdList.filter(
      (x) => x.ADDTIONALROW == 0 || x.ADDTIONALROW == null
    ).forEach((x) => {
      this.TrnMainObj.TOTAMNT += x.AMOUNT;
    });
    //calculating flat discount. If GblReplaceIndividualWithFlat=1 or 0
    var i: number = 0;
    var amt: number = 0;
    this.TrnMainObj.ProdList.forEach((x) => {
      amt +=
        x.AMOUNT -
        this.nullToZeroConverter(x.INDDISCOUNT) -
        this.nullToZeroConverter(x.PROMOTION) -
        this.nullToZeroConverter(x.LOYALTY);
    });
    this.TrnMainObj.ProdList.forEach((prod) => {
      i++;
      prod.SNO = i;
      if (this.TrnMainObj.ReplaceIndividualWithFlatDiscount == 1) {
        if (this.TrnMainObj.TOTALFLATDISCOUNT != 0) {
          prod.INDDISCOUNT = 0;
        }
      }
      if (amt == 0) {
        prod.FLATDISCOUNT = 0;
      } else {
        prod.FLATDISCOUNT =
          (prod.AMOUNT -
            this.nullToZeroConverter(prod.INDDISCOUNT) -
            this.nullToZeroConverter(prod.PROMOTION) -
            this.nullToZeroConverter(prod.LOYALTY)) *
          (this.nullToZeroConverter(this.TrnMainObj.TOTALFLATDISCOUNT) / amt);
      }

      prod.DISCOUNT =
        this.nullToZeroConverter(prod.INDDISCOUNT) +
        this.nullToZeroConverter(prod.FLATDISCOUNT) +
        this.nullToZeroConverter(prod.PROMOTION) +
        this.nullToZeroConverter(prod.LOYALTY);
      if (prod.ISSERVICECHARGE == 1) {
        prod.SERVICETAX = (prod.AMOUNT - prod.DISCOUNT) * this.ServiceTaxRate;
      }
      // if (prod.ISVAT == 1) {
      prod.TAXABLE =
        prod.AMOUNT - prod.DISCOUNT + this.nullToZeroConverter(prod.SERVICETAX);
      // prod.VAT = prod.TAXABLE * this.VatRate;
      prod.NONTAXABLE = 0;
      prod.NCRATE = prod.RATE * prod.EXRATE;
      // if (prod.REALQTY_IN == 0)
      // { prod.NCRATE = prod.PRATE; }
      // else
      // { prod.NCRATE = prod.TAXABLE / this.nullToZeroConverter(prod.REALQTY_IN); }
      // }
      // else {
      // prod.TAXABLE = 0; prod.VAT = 0;
      // prod.NONTAXABLE = prod.AMOUNT - prod.DISCOUNT + this.nullToZeroConverter(prod.SERVICETAX);
      // prod.NCRATE = prod.RATE * prod.EXRATE;
      // // if (prod.REALQTY_IN == 0)
      // // { prod.NCRATE = prod.PRATE; }
      // // else
      // // { prod.NCRATE = prod.NONTAXABLE / this.nullToZeroConverter(prod.REALQTY_IN); }
      // }
      // prod.NETAMOUNT = (this.nullToZeroConverter(prod.TAXABLE) + this.nullToZeroConverter(prod.NONTAXABLE) + this.nullToZeroConverter(prod.SERVICETAX) + this.nullToZeroConverter(prod.VAT));
      // prod.VAT = prod.NETAMOUNT-(this.nullToZeroConverter(prod.TAXABLE) + this.nullToZeroConverter(prod.NONTAXABLE) + this.nullToZeroConverter(prod.SERVICETAX) + this.nullToZeroConverter(prod.VAT));
    });
    // for(let i of this.TrnMainObj.ProdList){

    //     if(i.MCODE==this.MCODE){
    //         i.NETAMOUNT=i.NETAMOUNT*1.13
    //         i.VAT=i.NETAMOUNT-(i.NETAMOUNT/1.13)
    //     }

    //     // }
    // }
    this.TrnMainObj.TOTAMNT = 0;
    this.TrnMainObj.ProdList.forEach((x) => {
      this.TrnMainObj.TOTAMNT += x.AMOUNT;
    });
    this.TrnMainObj.TOTALINDDISCOUNT = 0;
    this.TrnMainObj.ProdList.forEach((x) => {
      this.TrnMainObj.TOTALINDDISCOUNT += this.nullToZeroConverter(
        x.INDDISCOUNT
      );
    });
    this.TrnMainObj.TOTALLOYALTY = 0;
    this.TrnMainObj.ProdList.forEach((x) => {
      this.TrnMainObj.TOTALLOYALTY += this.nullToZeroConverter(x.LOYALTY);
    });
    this.TrnMainObj.TOTALPROMOTION = 0;
    this.TrnMainObj.ProdList.forEach((x) => {
      this.TrnMainObj.TOTALPROMOTION += this.nullToZeroConverter(x.PROMOTION);
    });
    this.TrnMainObj.DCAMNT = 0;
    this.TrnMainObj.ProdList.forEach((x) => {
      this.TrnMainObj.DCAMNT += this.nullToZeroConverter(x.DISCOUNT);
    });
    this.TrnMainObj.ServiceCharge = 0;
    this.TrnMainObj.ProdList.forEach((x) => {
      this.TrnMainObj.ServiceCharge += this.nullToZeroConverter(x.SERVICETAX);
    });
    this.TrnMainObj.TAXABLE = 0;
    this.TrnMainObj.ProdList.forEach((x) => {
      this.TrnMainObj.TAXABLE += this.nullToZeroConverter(x.TAXABLE);
    });
    // alert("reached VAT 1")
    this.TrnMainObj.NONTAXABLE = 0;
    this.TrnMainObj.ProdList.forEach((x) => {
      this.TrnMainObj.NONTAXABLE += this.nullToZeroConverter(x.NONTAXABLE);
    });
    this.TrnMainObj.VATAMNT = 0;
    this.TrnMainObj.ProdList.forEach((x) => {
      this.TrnMainObj.VATAMNT += this.nullToZeroConverter(x.VAT);
    });
    this.TrnMainObj.NETWITHOUTROUNDOFF = 0;
    this.TrnMainObj.ProdList.forEach((x) => {
      this.TrnMainObj.NETWITHOUTROUNDOFF += this.nullToZeroConverter(
        x.NETAMOUNT
      );
    });
    this.TrnMainObj.NETAMNT = Math.round(
      this.nullToZeroConverter(this.TrnMainObj.NETWITHOUTROUNDOFF)
    );
    this.TrnMainObj.ROUNDOFF =
      this.TrnMainObj.NETAMNT - this.TrnMainObj.NETWITHOUTROUNDOFF;
    this.TrnMainObj.TotalWithIndDiscount = 0;
    this.TrnMainObj.ProdList.forEach((x) => {
      this.TrnMainObj.TotalWithIndDiscount += this.nullToZeroConverter(x.TOTAL);
    });
    this.TrnMainObj.TOTALDISCOUNT = 0;
    this.TrnMainObj.ProdList.forEach((x) => {
      this.TrnMainObj.TOTALDISCOUNT += this.nullToZeroConverter(x.DISCOUNT);
    });
    this.productForm.patchValue({
      TAXABLE: this.TrnMainObj.TAXABLE,
      NONTAXABLE: this.TrnMainObj.NONTAXABLE,
      ROUNDOFF: this.TrnMainObj.ROUNDOFF,
      NETAMNT: this.TrnMainObj.NETAMNT,
    });
  }

  nullToZeroConverter(value: any) {
    if (value == undefined || value == null) {
      return 0;
    }
    return +value;
  }
  ngOnDestroy() {
    try {
      this.subscriptions.forEach((sub: Subscription) => {
        sub.unsubscribe();
      });
    } catch (ex) {}
  }
  onClickYes() {
    this.childModal.hide();
    this.AddItem();
  }
  onClickNo() {
    this.productForm.patchValue({
      BC: '',
      MENUCODE: '',
      selectedProd: '',
      SelectedAltUnit: '',
      RATE: '',
      Quantity: '',
      AMOUNT: '',
      IndDiscountValue: '',
      EXPDATE: null,
      ITEMTYPE: '',
      RECEIVEDTYPE: '',
    });
    this.childModal.hide();
    return;
  }

  getPreviousAccountOpeningBalance(mcode: string) {
    this.masterService
      .getSingleObject(
        {
          division: this.TrnMainObj.DIVISION,
          mcode: mcode,
          vt: this.voucherType,
        },
        '/getprevacopeningbl'
      )
      .subscribe((data: any) => {
        if (data.status == 'ok') {
          if (data.result != null && data.result.length > 0) {
            this.previousOpeningStockData = data.result;
          }
        } else {
          alert(data.result);
        }
      });
  }

  curencyConvert(rate: any) {
    var C = this.masterService.Currencies.find(
      (x) => x.CURNAME == this.TrnMainObj.FCurrency
    );
    if (C != null) {
      return C.EXRATE * rate;
    } else return rate;
  }

  InvMain: any = <any>{};
  JID: any;
  JobObj: any = <any>{};
  InvMainProd: any[] = [];
  PList: any[] = [];
  jobcardProd: any[] = [];
  jobValue: any;
  isEnter = false;
  // this.DialogMessage = "Cannot find delivery-out items! "
  // this.childModal.show();
  // setTimeout(() => {
  //     this.childModal.hide();
  // }, 2000)
  EnterJob(event: any) {
    if (this.masterService.DispatchName == 'DispatchIn') {
      this.isEnter = true;
      console.log('Events', event);
      // this. checkValidity();
      //this.JobChanged(event);
    }
  }

  JobChanged(event: any) {
    console.log('job card changed', event);
    this.masterService.getJobCardFromID(event._id).subscribe((res: any) => {
      console.log('result from job chnages', res);
      this.productForm.patchValue({
        CUSNAME: res.result.cname,
        ENGINE: res.result.engineno,
        VEHNO: res.result.vehicleno,
        MODEL: res.result.model,
      });
    });
    this.checkValidity();
    if (event == '') {
      this.itemcheck = true;
    } else {
      this.itemcheck = false;
    }

    this.masterService._itemList = [];
    this.productForm.patchValue({
      MENUCODE: null,
      selectedProd: null,
      RATE: null,
      Quantity: null,
      AMOUNT: null,
    });
    var a = event;
    this.jobValue = event.jobCardCode;

    this._trnMainService.TrnMainObj.vehicleno = a.vehicleNo;
    this._trnMainService.TrnMainObj.JobCode = a.jobCardCode;
    this.JID = event._id;

    this.busy = this.masterService
      .getInvMainFromJobID(event._id)
      .subscribe((data: any) => {
        console.log('dataaaa', data);
        this.sumList = data.result.Sum;
        console.log('sum', this.sumList);
        this.sumListForItems = this.sumList;
        this.warranty = data;
        this.newWarranty = this.warranty;
        console.log(
          'warrantyyyy',
          this.warranty,
          this.masterService.DispatchName
        );
        if (this.masterService.DispatchName == 'DispatchIn') {
          this.masterService.DRJobNO = a.jobCardCode; //for validation of Jobselect while save on Delivery
          if (data.status == 'ok') {
            console.log('length', data.result.res);
            if (data.result.res.length == 0) {
              this.masterService._itemList = [];
              if (this.isEnter == true) {
                this.DialogMessage = 'Cannot find delivery-out items! ';
                this.childModal.show();
                setTimeout(() => {
                  this.isEnter = false;
                  this.childModal.hide();
                }, 2000);
              }
              return;
            } else {
              this.itemcheck = true;
              this.masterService._itemList = [];
              this.result = data.result.res;
              this.sumList = data.result.Sum;
              console.log('sum', this.sumList);

              this.InvMain = data.result; //data return in list bcoz it has to check either Deliver out or In
              console.log('Deliveryout Products', data.result.res);
              for (let i of data.result.res) {
                console.log('item loop', i);
                let a: any = <any>{};
                a.DESCA = i.ProdList.ITEMDESC;
                a.RATE = i.ProdList.RATE;
                a.MCODE = i.ProdList.MCODE;
                a.Quantity = i.ProdList.Quantity;
                a.MENUCODE = i.ProdList.MENUCODE;
                a.warranty = i.ProdList.warranty;
                this.w = i.ProdList.Warranty;
                this.warranty = this.w;

                console.log('www', this.w);

                this.masterService._itemList.push(a);
              }
            }
          }
        } else {
          this.masterService.DLJobNO = a.jobCardCode;
          this.itemcheck = true;
        }
        if (data.status == 'error') {
          this.DialogMessage = 'Error in Saving Data:' + data.result._body;
          setTimeout(() => {
            this.childModal.hide();
          }, 3000);
        }
      });
  }
  hideChildModal() {
    this.childModal.hide();
  }
  quantityEnter(value: any) {}

  JobnoItem = (keyword: any): Observable<Array<any>> => {
    return new Observable((observer: Subscriber<Array<any>>) => {
      let sub11 = this.masterService
        .OpenFlag()
        .pipe(
          map((fList: any) => {
            return fList.filter((data: any) =>
              data.jC_Code == null
                ? ''
                : data.jC_Code.toUpperCase().indexOf(keyword.toUpperCase()) > -1
            );
          })
        )
        .pipe(map((res: any) => res.slice(0, 20)))
        .subscribe(
          (data: any) => {
            observer.next(data);
          },
          (Error: any) => {
            observer.complete();
          },
          () => {
            observer.complete();
          }
        );
      this.subscriptions.push(sub11);
    });
  };

  EnterJobNo() {
    this.gridJCListSettings = {
      title: 'Job Card List',
      apiEndpoints: `/V2/GetOpenFlagVehicleOnly_Paged`,
      DataSource: DataSourceType.ServerDataSource,
      defaultFilterIndex: 0,
      LocalData: [],
      columns: [
        {
          key: '_id',
          title: 'Job Card no.',
          hidden: false,
          noSearch: false,
        },
      ],
    };

    this.genericGridJCList.show();
  }

  onJCSelect(event: any) {
    console.log('selected jc', event);
    this.EnterJob(event);
    this.selectedJobNo = event.jobCardCode;
    this.TrnMainObj.JobCode = this.selectedJobNo;
    this.JobChanged(event);
    this.genericGridJCList.focusAnyControl('MENUCODE');
  }

  EnterMENUCODE(event: any) {
    event.preventDefault();
    this.gridMENUCODEsettings = {
      title: 'Product List',
      apiEndpoints: `/V2/getProductList`,
      DataSource: DataSourceType.ServerDataSource,
      LocalData: [],
      defaultFilterIndex: 1,
      columns: [
        {
          key: 'menucode',
          title: 'MenuCode',
          hidden: false,
          noSearch: false,
        },
        {
          key: 'desca',
          title: 'DESCRIPTION',
          hidden: false,
          noSearch: false,
        },
        {
          key: 'unit',
          title: 'Unit',
          hidden: false,
          noSearch: true,
        },
        {
          key: 'rate',
          title: 'Rate',
          hidden: false,
          noSearch: false,
        },
        {
          key: 'qty',
          title: 'Quantity',
          hidden: this.inputVchrType == 'dispatchin' ? false : true,
          noSearch: true,
        },
      ],
    };

    this.genericGridProductList.show();
  }

  EnterMENUCODE2(event: any) {
    event.preventDefault();
    this.gridMENUCODEsettings = {
      title: 'Product List',
      apiEndpoints: `/V2/getProductList`,
      DataSource: DataSourceType.ServerDataSource,
      LocalData: [],
      defaultFilterIndex: 0,
      columns: [
        {
          key: 'menucode',
          title: 'MenuCode',
          hidden: false,
          noSearch: false,
        },
        {
          key: 'desca',
          title: 'DESCRIPTION',
          hidden: false,
          noSearch: false,
        },
        {
          key: 'rate',
          title: 'Rate',
          hidden: false,
          noSearch: false,
        },
        {
          key: 'qty',
          title: 'Quantity',
          hidden: this.inputVchrType == 'dispatchin' ? false : true,
          noSearch: true,
        },
      ],
    };

    this.genericGridProductList.show();
  }

  GetPoductFromCode(event: any) {}
  onProductSelect(event: any) {
    console.log('product selected', event);
    if (event == null || event == undefined) {
      return;
    }
    if (typeof event === 'object') {
      if (this.warrantyURL === '/pages/inventory/dispatch') {
        this.warranty = '0';
        this.focusAnyControl('quantityBox');
      } else {
        this.warranty = '1';
      }
      if (this.warrantyURL === '/pages/inventory/dispatchIn') {
        var deep = _.cloneDeep(event);
        this.warranty = deep.warranty;
        console.log(this.warranty, 'deep warranty');
        this.focusAnyControl('quantityBox');
      }
    }

    if (typeof event === 'object') {
      console.log('inside');
      this.masterService.getDetailsFromMcode(event).subscribe((data: any) => {
        this.mcode = data.result.mcode;
        this.TrnProdObj = <TrnProd>{};
        this.TrnProdObj.ITEMDESC = data.result.desca;
        this.TrnProdObj.RATE = data.result.rate;
        this.TrnProdObj.MENUCODE = data.result.menucode;
        this.TrnProdObj.MCODE = this.MCODE = data.result.mcode;
        this.TrnProdObj.UNIT = data.result.unit;

        if (this.masterService.DispatchName == 'DispatchIn') {
          for (let i of this.PList) {
            //PList comes when we enter JOBID
            if (this.TrnProdObj.MENUCODE == i.MENUCODE) {
              //TrnProdObj is the item we selected
              this.productForm.patchValue({
                //Auto Patch value of Quantity and Discount for Delivery In
                Quantity: i.Quantity,
                IndDiscountValue: i.INDDISCOUNT,
                EXPDATE: i.EXPDATE,
                radioIndDiscount: 'amt',
              });
              if (i.quantity != 0) {
                this.txtQuantityChange(i.discount);
              }
            }
          }
        }
        console.log({ result: data.result, trnprodobj: this.TrnProdObj });
        this.productForm.patchValue({
          MENUCODE: this.TrnProdObj.MENUCODE,
          RATE: this.TrnProdObj.RATE,
          selectedProd: this.TrnProdObj.ITEMDESC,
          // Quantity: this.TrnProdObj.Quantity,
          // EXPDATE: this.TrnProdObj.EXPDATE,
          //  ITEMTYPE: this.TrnProdObj.ITEMTYPE,
          //   RECEIVEDTYPE: this.TrnProdObj.RECEIVEDTYPE,
          //   IndDiscountValue:this.TrnProdObj.DISCOUNT,
        });
        this.genericGridProductList.focusAnyControl('rateBox');
        // this.form.patchValue({

        // })
        // this.changedate(data.result.licence_expdate.substring(0, 10), "AD", "LicenceExp");
      });
    }
  }
  Catchtab() {
    this.genericGridProductList.focusAnyControl('warranty');
  }
  onFocusAdd() {
    this.genericGridProductList.focusAnyControl('add');
  }
  focusAnyControl(id: string) {
    let control: any = document.getElementById(id);
    if (control != null) {
      setTimeout(() => {
        control.focus();
      });
    }
  }

  async getProductFromMenuCode(event: any) {
    var data = await this.masterService.getProductFromCode(event.target.value);
    console.log({ getproductfromMenucodeRet: data });
    if (data.status == 'error') return;

    this.mcode = data.result.mcode;
    this.TrnProdObj = <TrnProd>{};
    this.TrnProdObj.ITEMDESC = data.result.desca;
    this.TrnProdObj.RATE = data.result.rate;
    this.TrnProdObj.MENUCODE = data.result.menucode;
    this.TrnProdObj.MCODE = this.MCODE = data.result.mcode;
    this.TrnProdObj.UNIT = data.result.unit;
    //this.TrnProdObj.EXPDATE=data.result.expdate;
    // this.TrnProdObj.DISCOUNT=data.result.DISAMOUNT;
    if (this.masterService.DispatchName == 'DispatchIn') {
      for (let i of this.PList) {
        //PList comes when we enter JOBID
        if (this.TrnProdObj.MENUCODE == i.MENUCODE) {
          //TrnProdObj is the item we selected
          this.productForm.patchValue({
            //Auto Patch value of Quantity and Discount for Delivery In
            Quantity: i.Quantity,
            IndDiscountValue: i.INDDISCOUNT,
            EXPDATE: i.EXPDATE,
            radioIndDiscount: 'amt',
          });
          if (i.quantity != 0) {
            this.txtQuantityChange(i.discount);
          }
        }
      }
    }
    console.log({ result: data.result, trnprodobj: this.TrnProdObj });
    this.productForm.patchValue({
      MENUCODE: this.TrnProdObj.MENUCODE,
      RATE: this.TrnProdObj.RATE,
      selectedProd: this.TrnProdObj.ITEMDESC,
      // Quantity: this.TrnProdObj.Quantity,
      // EXPDATE: this.TrnProdObj.EXPDATE,
      //  ITEMTYPE: this.TrnProdObj.ITEMTYPE,
      //   RECEIVEDTYPE: this.TrnProdObj.RECEIVEDTYPE,
      //   IndDiscountValue:this.TrnProdObj.DISCOUNT,
    });
    // this.genericGridProductList.focusAnyControl('quantityBox');
    // this.form.patchValue({

    // })
    // this.changedate(data.result.licence_expdate.substring(0, 10), "AD", "LicenceExp");
  }
  delRowCategory(index: any) {
    console.log({ Yeta: index, prodlist: this.TrnMainObj.ProdList });
    this.TrnMainObj.ProdList.splice(index, 1);
  }
}
